import React from "react";
import noop from "lodash/fp/noop";

export type OptionProps = {
  text: string;
  value: string;
  onClick?: (value: string) => void;
  className?: string;
};

const Option = ({ text, value, onClick = noop, className }: OptionProps) => (
  <option value={value} onClick={() => onClick(value)} className={className}>
    {text}
  </option>
);

export default Option;
